import { Button } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { navigateGroup } from "authoring/routes/project/utilities/project-navigation"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import Iconify from "minimals-template/components/Iconify"
import { useSimilaritySelection } from "../similarity-selection-context"
import { addComponentTasksToGlobalUpdate } from "../../controller/add-component-tasks-to-global-update"

export function AddComponentTasksButton() {
    const { project, groupId, sourceTask, search } = useBoundContext()
    const { allMatching, selectedTasks, excludedTasks, selectedCount, clearSelection } = useSimilaritySelection()

    return (
        <Button
            variant="contained"
            onClick={handleAdd}
            disabled={!selectedCount || !sourceTask}
            data-cy="add-tasks-to-global-update-button"
            startIcon={<Iconify icon="ic:round-add" />}
        >
            Add Tasks to Global Update
        </Button>
    )

    async function handleAdd() {
        try {
            const savedCount = await addComponentTasksToGlobalUpdate({
                projectId: project.id,
                groupId,
                componentId: sourceTask.id,
                componentVersion: sourceTask.componentVersion,
                selection: {
                    search,
                    allMatching,
                    selectedIds: Object.keys(selectedTasks),
                    excludedIds: Object.keys(excludedTasks),
                },
            })
            if (!savedCount) {
                errorSnackbar("None of the selected tasks could be added to the global update")
                return
            }

            clearSelection()
            successSnackbar(`${savedCount} ${"task".pluralize(savedCount)} added to global update`)
            navigateGroup({ projectId: project.id, groupId })
        } catch (error) {
            console.error(error)
            errorSnackbar(error?.message || "Failed to add tasks to global update")
        }
    }
}
